// src/components/TopBar.jsx
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import "../CSS/TopBar.css"; // Ensure this file is in the correct location

const TopBar = () => {
  const [modalContent, setModalContent] = useState(null);

  const handleOpenModal = (type) => {
    let title, content;

    switch (type) {
      case "terms":
        title = "Terms & Conditions";
        content = (
          <>
            <p>
              Welcome to our website. By accessing this site, you agree to abide by the terms
              and conditions outlined herein. This website is operated by an ASIC Design and
              Verification company focused on high‐performance SoC design solutions for semiconductor clients.
            </p>
            <p>
              All content provided is for informational purposes only and does not constitute
              a binding offer. We reserve the right to update or modify these terms at any time
              without notice. Continued use of the site implies acceptance of any changes.
            </p>
            <p>
              All intellectual property, including logos, designs, and documentation, remains
              the property of the company and may not be copied or distributed without explicit
              permission.
            </p>
            <p>
              This website may contain links to third‐party services or tools. We are not
              responsible for the content or privacy practices of such third‐party services.
            </p>
          </>
        );
        break;

      case "privacy":
        title = "Privacy Policy";
        content = (
          <>
            <p>
              We value your privacy. This policy outlines how we collect, use, and protect
              your personal data. By interacting with our website, you consent to the data
              practices described in this policy.
            </p>
            <p>
              We may collect your name, email, and phone number if voluntarily submitted
              through contact forms. This information will be used solely to respond to
              inquiries and will not be shared with third parties without consent.
            </p>
            <p>
              We implement security measures to protect your data, but we cannot guarantee
              complete security over the internet. You have the right to access or request
              deletion of your data at any time.
            </p>
            <p>
              Analytics tools may collect anonymized usage data to help us improve the user
              experience. This data is never linked back to individual users.
            </p>
          </>
        );
        break;

      default:
        return;
    }

    setModalContent({ title, content });
  };

  const handleCloseModal = () => {
    setModalContent(null);
  };

  return (
    <>
      {/* ============================= */}
      {/* TOP BAR (VISIBLE AT ALL TIMES) */}
      {/* ============================= */}
      <motion.div
        className="ntb-top-bar"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -30 }}
        transition={{ duration: 0.3 }}
      >
        <div className="ntb-top-bar-content">
          <div className="ntb-left-section">
            <a href="mailto:support@neridtech.com" className="ntb-email">
              support@neridtech.com
            </a>
            <span className="ntb-separator">|</span>
            <a href="tel:+381651234567" className="ntb-phone">
              +381 65 123 4567
            </a>
          </div>
          <div className="ntb-right-section">
            <Link to="#" onClick={() => handleOpenModal("terms")} className="ntb-link">
              Terms & Conditions
            </Link>
            <span className="ntb-separator">|</span>
            <Link to="#" onClick={() => handleOpenModal("privacy")} className="ntb-link">
              Privacy Policy
            </Link>
            <span className="ntb-separator">|</span>
            <Link to="/careers/job-openings" className="ntb-link">
              Careers
            </Link>
          </div>
        </div>
      </motion.div>

      {/* ============================= */}
      {/* MODAL (FADES IN WHEN modalContent != null) */}
      {/* ============================= */}
      <AnimatePresence>
        {modalContent && (
          <>
            {/* Backdrop */}
            <motion.div
              className="ntb-modal-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.6 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={handleCloseModal}
            />

            {/* Modal wrapper */}
            <motion.div
              className="ntb-modal-wrapper"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <div className="ntb-modal-container">
                {/* Header with title + close (“×”) */}
                <div className="ntb-modal-header">
                  <h2 className="ntb-modal-title">{modalContent.title}</h2>
                  <button
                    className="ntb-modal-close-btn"
                    aria-label="Close"
                    onClick={handleCloseModal}
                  >
                    &times;
                  </button>
                </div>

                {/* Body: scrollable content */}
                <div className="ntb-modal-body">{modalContent.content}</div>

                {/* Footer with Close button */}
                <div className="ntb-modal-footer">
                  <button
                    className="ntb-modal-footer-close"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default TopBar;